// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import 'lib-flexible'
import VueWechatTitle from 'vue-wechat-title'
import VueSession from 'vue-session'
import './utils/dialog'
import qs from 'qs'

import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'

import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true
Vue.use(VueClipboard)


Vue.use(VueQuillEditor)

Vue.prototype.HOST_URL = 'http://localhost:8081/checking'
Vue.config.productionTip = false
Vue.prototype.axios = axios
Vue.prototype.$qs = qs

// 常量
Vue.prototype.SETTING_SHOW_POSITION = 'show_position' // 是否显示成绩排名

Vue.directive('focus', function(el) {
  el.focus()
})

Vue.prototype.isNumber = function(val) {
  var regPos = /^\d+(\.\d+)?$/ // 非负浮点数
  var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/ // 负浮点数
  if (regPos.test(val) || regNeg.test(val)) {
    return true
  } else {
    return false
  }
}

/**
判断字符串是否是手机号码，若是则返回true,若否则返回false
**/
Vue.prototype.isPhone = function(phone) {
  return /^1(3\d|4\d|5\d|6\d|7\d|8\d|9\d)\d{8}$/g.test(phone)
}

/**
 * 判断是否为空对象，字符串为空
 */
Vue.prototype.isEmpty = function(obj) {
  if (typeof obj === 'undefined' || obj == null || obj == '') {
    return true
  } else {
    return false
  }
}

Vue.use(VueWechatTitle)
Vue.use(VueSession)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    App
  },
  template: '<App/>'
})

// new Vue({
//   el: '#app',
//   router,
//   store,
//   render: h => h(App),
//   mounted () {
//     document.dispatchEvent(new Event('render-event'))
//     }
// }).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js